import React, { useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import BackButton from '../../../../../../components/UI/BackButton';
import ButtonUI from '../../../../../../components/UI/ButtonUI';
import InputUI from '../../../../../../components/UI/InputUI';
import ScannerCode from '../../../../../../components/UI/ScannerCode';
import DeliveryService from '../../../../../../services/DeliveryService';
import { validateInputsRequired } from '../../../../../../utils/handleChangeHooks';
import { isNullOrEmpty, showMessageToastCustom, translate } from '../../../../../../utils/util';

const MissionDeliveryDetail = (props) => {
    const [pdu, setPdu] = useState();
    const [order, setOrder] = useState({});

    useEffect(() => {
        const inputPdu = document.getElementById('pdu');
        if (inputPdu) {
            inputPdu.focus();
        }
    }, []);

    useEffect(() => {
        if (props.order && props.order?.items[0]) {
            setOrder(props.order)
        }
    }, [props.order]);

    const scannerPdu = (value) => {
        if (!isNullOrEmpty(value)) {
            setPdu(value);
        }
    };

    const confirm = () => {
        if (validateInputsRequired("formMissionDelivery")) {
            if (order.items[0]?.nextLocation !== pdu) {
                return showMessageToastCustom(translate('general:warning'), "PDU informado não confere", 3000, 'mdi mdi-alert-circle-outline red-text');
            }

            props.confirmPdu(pdu, order.orderId, () => {
                props.history.go(-1);
            });
            return true;
        }
    }

    return (
        <div>
            <BackButton {...props} />
            <div className="container-fluid h-65">
                <div className="row">
                    <div className="title">
                        <i className="mdi mdi-camera-timer" />
                        {translate('title', 'delivery')}
                    </div>
                    <div className="subtitle">
                        | <i className="material-icons">playlist_add_check</i>
                        {translate('expedition:picking.missions')}
                    </div>
                </div>
            </div>
            {
                order?.items && (
                    <div className="container" style={{ marginTop: '35px', }}>
                        <div className="card">
                            <div className="card-content" style={{ padding: '4px' }}>
                                <form>
                                    <div className="row" style={{ marginBottom: '0' }}>
                                        <div className="input-field no-padding col s6  mb-8" style={{ marginRight: '0' }} >
                                            <span className="field f-1p45r">{order?.items[0]?.cim}</span>
                                            <label className="active" htmlFor="cim">{translate('line-picking:linepicking.CIM')}</label>
                                        </div>
                                        <div className="input-field no-padding col s6  mb-8" style={{ marginRight: '0' }}>
                                            <span className="field f-1p45r">{order?.items[0]?.partnumber}</span>
                                            <label className="active" htmlFor="partnumber">{translate('expedition:picking.partnumber')}</label>
                                        </div>
                                        <div className="input-field no-padding col s12 mb-8" style={{ marginRight: '0' }}>
                                            <span className="field f-1r">{order?.items[0]?.description}</span>
                                            <label className="active" htmlFor="description">{translate('expedition:picking.description')}</label>
                                        </div>
                                        <div className="input-field no-padding col s6 mb-8" style={{ marginRight: '0' }}>
                                            <span className="field f-1r">{order?.orderCode}</span>
                                            <label className="active" htmlFor="ordercode">{translate('expedition:picking.orderCode')}</label>
                                        </div>
                                        <div className="input-field no-padding col s6 mb-8" style={{ marginRight: '0' }}>
                                            <span className="field f-1r">{order.items[0]?.nextLocation}</span>
                                            <label className="active" htmlFor="PDU">{translate('delivery:fields.pdu')}</label>
                                        </div>
                                        <div className="input-field no-padding col s6 mb-8" style={{ marginRight: '0' }}>
                                            <span className="field f-1r">{order.items[0]?.quantity}</span>
                                            <label className="active" htmlFor="quantity">{translate('expedition:picking.quantity')}</label>
                                        </div>
                                        <div className="input-field no-padding col s6 mb-8" style={{ marginRight: '0' }}>
                                            <span className="field f-1r">{order.route?.code}</span>
                                            <label className="active" htmlFor="productId">{translate('line-picking:linepicking.route')}</label>
                                        </div>
                                        <div id="formMissionDelivery" className="input-field no-padding col s12" style={{ marginTop: '3' }}>
                                            <ScannerCode className="mdi mdi-barcode-scan posfix disable" onScanner={scannerPdu} markerCodeBar={true} />
                                            <InputUI
                                                required
                                                label={translate('delivery:fields.pdu')}
                                                id="pdu"
                                                type="text"
                                                defaultValue={pdu || ""}
                                                onChange={(event) => { setPdu(event.target.value) }}
                                            />
                                        </div>
                                    </div>
                                    <div className="row" style={{ paddingTop: '8px' }}>
                                        <ButtonUI full="true" onClick={confirm} text={translate('general:confirm')} />
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                )
            }
        </div >
    );
}

const mapStateToProps = (state) => {
    return {
        order: state.deliveryReducer.order,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        confirmPdu: (orderId, location, callback) => {
            dispatch(DeliveryService.ConfirmationDeliveryUrgent(location, orderId, callback));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(MissionDeliveryDetail)));
